<template>
  <div class="home">
    <header>
      <div class="head">
        <div class="hleft">
          <div class="logo">
            <img src="../assets/logo.png" alt />
            <div class="cTitle">
              <h2>北京天蔚中医药发展促进中心</h2>
              <h4>BeijingTianweiPromotionCenter</h4>
            </div>
          </div>
        </div>
        <div class="hright">
          <div class="nav">
            <div
              ref="line"
              :style="`left:${0.9 * navCurrentIndex + 0.15}rem`"
              class="line"
            ></div>
            <ul>
              <li ref="he" v-for="(item, index) in nav" :key="item.title">
                <h2
                  :style="index == navCurrentIndex ? 'color:#fe7333;' : ''"
                  @click="toLink(item, index)"
                >
                  {{ item.title }}
                </h2>
              </li>
            </ul>
          </div>
          <div class="search">
            <el-input
              placeholder="输入内容后按回车"
              suffix-icon="el-icon-search"
              @keyup.enter.native="search"
              v-model="keyword"
              size="mini"
              style="width: 2rem"
            ></el-input>
            <div class="userInfo">
              <div class="lInfo" v-if="Object.keys(userInfo).length > 0">
                <el-dropdown
                  trigger="click"
                  placement="bottom"
                  @command="setDialogInfo"
                >
                  <span class="el-dropdown-link">
                    <img :src="userInfo.head" alt />
                  </span>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item command="info">个人信息</el-dropdown-item>
                    <!-- <el-dropdown-item command="password">修改密码</el-dropdown-item> -->
                    <el-dropdown-item command="logout"
                      >退出登录</el-dropdown-item
                    >
                  </el-dropdown-menu>
                </el-dropdown>
              </div>
              <div v-else class="userlogin"></div>
            </div>
          </div>
        </div>
      </div>
    </header>
    <keep-alive>
      <transition mode="out-in">
        <router-view></router-view>
      </transition>
    </keep-alive>
    <footer class="wow fadeInUp" data-wow-duration=".5s">
      <div class="fot">
        <div
          class="content wow fadeInLeft"
          data-wow-delay=".5s"
          data-wow-duration=".5s"
        >
          <div class="logo">
            <img src="../assets/logo.png" alt />
            <div class="cTitle">
              <h2>北京天蔚中医药发展促进中心</h2>
              <h4>BeijingTianweiPromotionCenter</h4>
            </div>
          </div>
          <div class="phone">
            <h4><span>电</span>话:010-53612925、18500567137</h4>
            <h4><span>邮</span>箱:bjtwzyy2017@163.com</h4>
            <h4><span>地</span>址:北京市海淀区清河嘉园西区1号</h4>
            <h4>技术支持:北京蔚来高科技术有限公司</h4>
          </div>
        </div>
        <div class="map">
          <el-amap
            vid="amapDemo"
            :center="center"
            :zoom="zoom"
            class="amap-demo"
            :events="events"
          >
            <el-amap-marker
              :position="marker.position"
              :events="marker.events"
              :visible="marker.visible"
              :draggable="marker.draggable"
            ></el-amap-marker>
          </el-amap>
        </div>
        <div
          class="fimg wow fadeInRight"
          data-wow-delay="1s"
          data-wow-duration=".5s"
        >
          <img src="../assets/ewm.jpg" alt />
          <p>公众号</p>
        </div>
      </div>
      <h1>
        北京天蔚中医药发展促进中心版权所有 |
        <a style="color: #fff; " href="https://beian.miit.gov.cn">
          京ICP备2020036376号-1
        </a>
      </h1>
    </footer>
    <div class="mtop" ref="top" @click="goTop">
      <i class="el-icon-caret-top"></i>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import Bus from "@/utils/bus.js"
import WOW from "wowjs"
import {
  Login,
  nextPassword,
  editPassword,
  getReCode,
  getBackCode,
} from "@/api/user.js"
export default {
  name: "Home",
  data() {
    let self = this
    return {
      zoom: 12,
      center: [116.349634, 40.03402],
      searchOption: {
        city: "全国",
        citylimit: true,
      },
      marker: {
        position: [116.349634, 40.03402],
      },
      address: "",
      events: {
        click(e) {
          let { lng, lat } = e.lnglat
          self.lng = lng
          self.lat = lat
          self.marker.position = [lng, lat]
          // 这里通过高德 SDK 完成。
          var geocoder = new AMap.Geocoder({
            radius: 1000,
            extensions: "all",
          })
          geocoder.getAddress([lng, lat], function(status, result) {
            if (status === "complete" && result.info === "OK") {
              if (result && result.regeocode) {
                self.address = result.regeocode.formattedAddress
                self.$nextTick()
              }
            }
          })
        },
      },
      lng: 0,
      lat: 0,
      nav: [
        {
          title: "首页",
          url: "pmain",
        },
        {
          title: "关于我们",
          url: "conntect",
        },
        {
          title: "中心动态",
          url: "news",
        },
        {
          title: "信息公开",
          url: "newsInfo",
        },
        {
          title: "项目展示",
          url: "program",
        },
        {
          title: "合作交流",
          url: "jlzx",
        },
        {
          title: "公益捐赠",
          url: "hzzx",
        },
      ],
      keyword: "",
      currentIndex: 0,
      navCurrentIndex: 0,
      moverIndex: -1,
      moverItem: {},
      userInfo: {},
    }
  },

  mounted() {
    this.getInfo()
    this.getCurrent()
    Bus.$on("getCurrent", (e) => {
      this.getCurrent(e)
    })
    window.addEventListener("scroll", this.scrollToTop)
    setTimeout(() => {
      let wow = new WOW.WOW({
        boxClass: "wow",
        animateClass: "animated",
        offset: 100,
        mobile: true,
        live: true,
      })
      wow.init()
    }, 200)
  },
  methods: {
    // 点击跳转
    toLink(item, index) {
      this.$router.push({ name: item.url, params: { title: true } })
      this.navCurrentIndex = index
    },
    //返回顶部
    goTop() {
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      })
    },
    // 检查是否被选中
    getCurrent(currentUrl) {
      this.nav.forEach((item, index) => {
        if (
          item.url ==
            window.location.pathname.substring(
              1,
              window.location.pathname.length
            ) ||
          item.url == currentUrl
        ) {
          this.navCurrentIndex = index
          return false
        }
      })
    },
    // 搜索
    search() {
      if (this.keyword) {
        // const sNew = this.$router.resolve({
        //   name: "search",
        //   query: { content: this.keyword }
        // });
        // this.keyword = "";
        // window.open(sNew.href, "_blank");
        this.$router.push({
          name: "search",
          query: { keyword: this.keyword },
        })
        Bus.$emit("getSearch")
        // this.keyword = "";
      } else {
        this.$message.warning("搜索内容不能为空")
      }
    },
    //获取用户信息和是否登录
    getInfo() {
      this.userInfo = this.$store.state.user.userInfo
      // this.$store.dispatch("checkToken");
      // this.isLogin = this.$store.state.isLogin;
      // this.userInfo = this.$store.state.userInfo;
      // if (this.userInfo.phone) {
      //   this.phone = this.userInfo.phone.replace(
      //     this.userInfo.phone.substring(3, 7),
      //     "****"
      //   );
      // }
    },
    // 滑动时触发
    scrollToTop() {
      let scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop
      let browserHeight = window.outerHeight //浏览器页面高度
      if (scrollTop > browserHeight) {
        this.$refs.top.style.display = "block"
      } else {
        this.$refs.top.style.display = "none"
      }
    },
    setDialogInfo(cmditem) {
      if (!cmditem) {
        this.$message("菜单选项缺少command属性")
        return
      }
      switch (cmditem) {
        case "info":
          // if (this.$store.state.isLogin) {
          this.showInfoList()
          // } else {
          //   this.$message.warning("当前用户身份过期，请退出重新登录");
          // }
          break
        case "password":
          if (this.$store.state.isLogin) {
            this.editPass()
          } else {
            this.$message.warning("当前用户身份过期，请退出重新登录")
          }
          break
        case "logout":
          this.logout()
          break
      }
    },
    showInfoList() {
      // 个人信息
      this.$router.push("/userInfo")
    },
    //退出登录
    logout() {
      // 清除token
      // localStorage.removeItem("Token")
      console.log("info", this.$store.state.user.userInfo)
      this.$store.commit("user/getUserInfo", {})
      console.log("info", this.$store.state.user.userInfo)

      console.log(
        "第二次判断",
        this.$store.state.user.userInfo.phone == undefined
      )
      this.getInfo()

      // // 页面跳转
      // this.getCookie();
      this.$router.push("/")
    },
  },
  components: {},
  //退出时移除事件
  destroyed() {
    window.removeEventListener("scroll", this.scrollToTop)
  },
}
</script>

<style lang="less" scoped>
@color: #512475;
#open {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  transition: all 0.3s ease-in-out;
  z-index: 95;
}

.info {
  margin-left: 30px;
  line-height: 2;

  h2 {
    font-size: 16px;
    color: #333333;
    font-weight: bold;
  }

  p {
    font-size: 14px;
    color: #666;
  }

  .line {
    width: 130px;
    height: 2px;
    margin-left: -20px;
    background-color: #555;
  }
}

.home {
  width: 100%;
  .mtop {
    i {
      width: 36px;
      height: 36px;
      position: fixed;
      right: 30px;
      bottom: 60px;
      border: 1px solid #ccc;
      border-radius: 50%;
      font-size: 22px;
      color: #4ccaff;
      display: flex;
      justify-content: center;
      align-items: center;
    }

    i:hover {
      color: #fff;
      background-color: #4accff;
    }
  }

  .v-enter {
    opacity: 0;
  }
  .v-enter-active {
    transition: 0.5s;
  }
  .v-enter-to {
    opacity: 1;
  }
  .v-leave {
    opacity: 1;
  }
  .v-leave-to {
    opacity: 0;
  }
  .v-leave-active {
    transition: 0.5s;
  }
  header {
    height: 70px;
    width: 100%;
    position: fixed;
    z-index: 100;
    top: 0;
    left: 0;
    .head {
      display: flex;
      .hleft {
        width: 300px;
        height: 70px;
        display: flex;
        align-items: center;
        justify-content: flex-end;
        border-right: 10px solid #0588c7;
        background-color: #fff;
        .logo {
          margin-right: 15px;
          display: flex;
          align-items: center;
          justify-content: flex-end;
          img {
            width: 44px;
            height: 44px;
          }
          .cTitle {
            margin-left: 4px;
            h2 {
              font-size: 14px;
              font-weight: bolder;
              margin-bottom: 4px;
            }
            h4 {
              font-size: 11px;
            }
          }
        }
      }
      .hright {
        flex: 1;
        height: 70px;
        background-color: rgba(0, 0, 0, 0.4);
        display: flex;
        justify-content: space-between;
        align-items: center;
        .nav {
          flex: 1;
          position: relative;
          .line {
            width: 60px;
            height: 4px;
            background-color: #fe7333;
            position: absolute;
            transition: 0.3s all linear;
            left: 0;
            bottom: 0;
          }
          ul {
            display: flex;
            align-items: center;
            color: #fff;
            li {
              width: 90px;
              height: 70px;
              line-height: 70px;
              text-align: center;
              font-size: 15px;
              position: relative;

              h2 {
                padding: 0 10px;
                margin-bottom: 20px;
                cursor: pointer;
              }
            }
          }
        }
        .search {
          width: 360px;
          height: 70px;
          display: flex;
          justify-content: flex-end;
          align-items: center;
          .userInfo {
            margin-left: 20px;
            margin-right: 100px;
            .userlogin {
              font-size: 14px;
              color: #fff;
              span {
                cursor: pointer;
              }
            }
            .lInfo {
              img {
                width: 30px;
                height: 30px;
                border-radius: 50%;
                cursor: pointer;
              }
            }
          }
        }
      }
    }
  }

  footer {
    width: 100%;
    background-color: #3b3b3b;
    color: #fff;
    padding: 30px 0;

    h1 {
      text-align: center;
      font-size: 14px;
      margin-top: 20px;
      color: #fff;
    }

    .fot {
      display: flex;
      width: 954px;
      margin: 0 auto;
      justify-content: space-between;

      .content {
        .logo {
          display: flex;
          align-items: center;
          img {
            width: 44px;
            height: 44px;
          }
          .cTitle {
            margin-left: 10px;
            h2 {
              font-size: 14px;
              font-weight: bolder;
              line-height: 1.5;
            }
            h4 {
              font-size: 8px;
            }
          }
        }
        .phone {
          margin-top: 20px;
          h4 {
            color: #fff;
            font-size: 14px;
            margin: 10px 0;
            letter-spacing: 1px;
            span {
              letter-spacing: 30px;
            }
          }
        }
      }

      .map {
        width: 300px;
        height: 120px;
        margin: 20px 0;
        padding: 0 20px;
        border-left: 1px solid #999999;
        border-right: 1px solid #999999;

        img {
          width: 100%;
          height: 100%;
        }
      }
      .fimg {
        margin-top: 25px;
        width: 110px;
        height: 110px;
        img {
          width: 100%;
          height: 100%;
        }
        p {
          margin-top: 10px;
          text-align: center;
        }
      }
    }
  }
  .rdialog {
    width: 350px;
    height: 525px;
    background-color: #fff;
    position: fixed;
    border-radius: 5px;
    top: 12%;
    left: calc((100vw - 350px) / 2);
    z-index: 100;
    font-size: 14px;
    color: #666;

    .select {
      margin: 30px 0 0 30px;
      font-size: 16px;
      color: #333;

      span {
        margin-right: 20px;
      }

      .selected {
        border-bottom: 3px solid #4ccaff;
        padding-bottom: 15px;
        font-weight: bold;
      }
    }

    .line {
      margin: 0 auto;
      margin-top: 20px;
      width: 290px;
      height: 2px;
      background-color: #eee;
    }

    .tiparea {
      display: flex;
      margin-top: 20px;
      p {
        span {
          cursor: pointer;
        }
      }
    }

    .canel {
      position: absolute;
      bottom: 20px;
      right: 30px;
      cursor: pointer;
    }
  }

  .dialog {
    width: 350px;
    height: 400px;
    background-color: #fff;
    position: fixed;
    border-radius: 5px;
    top: 25%;
    left: calc((100vw - 350px) / 2);
    z-index: 100;
    font-size: 14px;
    color: #666;

    .select {
      margin: 30px 0 0 30px;
      font-size: 16px;
      color: #333;

      span {
        margin-right: 20px;
      }

      .selected {
        border-bottom: 3px solid #4ccaff;
        padding-bottom: 15px;
        font-weight: bold;
      }
    }

    .line {
      margin: 0 auto;
      margin-top: 20px;
      width: 290px;
      height: 2px;
      background-color: #eee;
    }

    .tiparea {
      display: flex;
      justify-content: space-between;
      margin-top: 20px;
      p {
        span {
          cursor: pointer;
        }
      }
    }

    .canel {
      position: absolute;
      bottom: 20px;
      right: 30px;
      cursor: pointer;
    }
  }
}
</style>
